import {RepeaterFixation} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/binding/Binding';

export class EnumUtils
{
    public static isFixedRight(fixation:RepeaterFixation):boolean
    {
        return fixation == RepeaterFixation.FixedBoth || fixation == RepeaterFixation.FixedRight;
    }

    public static isFixedDown(fixation:RepeaterFixation):boolean
    {
        return fixation == RepeaterFixation.FixedBoth || fixation == RepeaterFixation.FixedDown;
    }

    public static createFixation(isFixedDown:boolean, isFixedRight:boolean):RepeaterFixation
    {
        if( isFixedDown && isFixedRight )
            return RepeaterFixation.FixedBoth;

        if( isFixedDown )
            return RepeaterFixation.FixedDown;

        if( isFixedRight )
            return RepeaterFixation.FixedRight;

        return RepeaterFixation.NotFixed;
    }

    public static fixationCaption(fixation:RepeaterFixation):string
    {
        switch( fixation )
        {
            case RepeaterFixation.NotFixed:
                return 'Not Fixed';
            case RepeaterFixation.FixedDown:
                return 'Down';
            case RepeaterFixation.FixedRight:
                return 'Right';
            case RepeaterFixation.FixedBoth:
                return 'Both';
        }

        return '';
    }
}
